/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../models/Node';
import { IReferenceResolver } from './IReferenceResolver';
import { LocalReferenceResolver } from './LocalReferenceResolver';

/**
 * Constructor.
 * @class
 * @author eric.wittmann@gmail.com
 */
export class ReferenceResolverChain implements IReferenceResolver {
    static instance : ReferenceResolverChain; public static instance_$LI$() : ReferenceResolverChain { if(ReferenceResolverChain.instance == null) ReferenceResolverChain.instance = new ReferenceResolverChain(); return ReferenceResolverChain.instance; };

    public static getInstance() : ReferenceResolverChain {
        return ReferenceResolverChain.instance_$LI$();
    }

    /*private*/ resolvers : Array<IReferenceResolver> = <any>([]);

    public constructor() {
        this.addResolver(new LocalReferenceResolver());
    }

    /**
     * @return {*[]} the resolvers
     */
    public getResolvers() : Array<IReferenceResolver> {
        return this.resolvers;
    }

    /**
     * @param {*} resolver
     */
    public addResolver(resolver : IReferenceResolver) {
        /* add */this.resolvers.splice(0, 0, resolver);
    }

    /**
     * @param {*} resolver
     */
    public removeResolver(resolver : IReferenceResolver) {
        /* remove */(a => { let index = a.indexOf(resolver); if(index>=0) { a.splice(index, 1); return true; } else { return false; }})(this.resolvers);
    }

    /**
     * 
     * @param {string} reference
     * @param {Node} from
     * @return {Node}
     */
    public resolveRef(reference : string, from : Node) : Node {
        for(let index197=0; index197 < this.resolvers.length; index197++) {
            let resolver = this.resolvers[index197];
            {
                let resolvedNode : Node = resolver.resolveRef(reference, from);
                if(resolvedNode != null) {
                    return resolvedNode;
                }
            }
        }
        return null;
    }
}
ReferenceResolverChain["__class"] = "io.apicurio.datamodels.core.util.ReferenceResolverChain";
ReferenceResolverChain["__interfaces"] = ["io.apicurio.datamodels.core.util.IReferenceResolver"];





ReferenceResolverChain.instance_$LI$();
